import classNames from "classnames/bind";
import { useState } from "react";
import { EyeIcon, HidePasswordIcon } from "../../../../components/Icons/Icons";
import { isValidateConfirm, isValidatePassword } from "../../../../utils";
import styles from './FormItem.module.css';
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

function FormItem({ warning, label, name, values, onChange, type, rules, register, placeholder, onSubmit, disable, style,typeVl="default" }) {
    const [showPass, setShowPass] = useState(false)
    const [changing, setChanging] = useState(false)
    const handleChangeValue = (e) => {
        if (!changing) {
            setChanging(true)
        }
        onChange(e.target.value)
    }
    const handleTogleHideShow = () => {
        setShowPass(!showPass)
    }

    const checkRules = (value) => {
        if ((changing || onSubmit) && rules && rules[0].isRequire) {
            if (!value || value.trim().length === 0) {
                return false
            }
        }
        if ((changing || onSubmit) && typeVl ==="default" && !isValidatePassword(value) && name !== 'oldPassword') {
            return false
        }
        if ((changing || onSubmit) && rules && rules[1] && rules[1].confirm && !isValidateConfirm(rules[1]?.confirm, value)) {
            return false
        }
        if ((changing || onSubmit) && rules && rules[1] && rules[1].newPass && isValidateConfirm(rules[1]?.newPass, value)) {
            return false
        }
        return true
    }
    const getMess = (value) => {
        if (rules && rules[0].isRequire) {
            if (!value || value.trim().length === 0) {
                return rules[0].mess ? rules[0].mess : "Vui lòng nhập trường này"
            }
        }
        if (typeVl ==="default" && !isValidatePassword(value) && name !== 'oldPassword') {
            return 'Dài trên 6 - 20 kí tự, bao gồm cả chữ, số, viết hoa, viết thường và cả những kí tự đặc biệt'
        }
        // if(type !=="default"){

        // }
        if (rules[1] && rules[1].confirm && !isValidateConfirm(rules[1]?.confirm, value)) {
            return 'Mật khẩu nhập lại không giống'
        }
        if (rules[1] && rules[1].newPass && isValidateConfirm(rules[1]?.newPass, value)) {
            return rules[1]?.mess;        
        }
    }
    return (
        <div className={cx('form-item', register ? 'register' : '')}>
            <div className={cx('input-group')}>
                <label className={cx('title')}>{label}</label>
                <div className={cx('input-item', checkRules(values) ? '' : 'error')} style={{...style}}>
                    <input
                        className={cx('input')}
                        name={name}
                        value={values ? values : ''}
                        onChange={handleChangeValue}
                        type={!showPass ? type : 'text'}
                        placeholder={placeholder}
                        disabled={disable}
                        autoComplete="off"
                    />
                    <span onClick={handleTogleHideShow}>{showPass ? <HidePasswordIcon /> : <EyeIcon />}</span>
                </div>
            </div>
            {(changing || onSubmit) && !checkRules(values) && (<span className={cx('error-report', register ? 'register-error' : '')}>{getMess(values)}</span>)}
            {
                warning && !changing ? <div className={cx('input-node')}>
                    <p className={cx('node-title')}>{warning}</p>
                </div> : ''
            }
        </div >
    )
}

FormItem.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    values: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    rules: PropTypes.any,
    register: PropTypes.bool,
    warning: PropTypes.string
}
export default FormItem;